import Heading from '@axa-japan/design-system-react/Heading';
import Lightbox from '@axa-japan/design-system-react/Lightbox';
import Pagination from '@axa-japan/design-system-react/Pagination';
import Text from '@axa-japan/design-system-react/Text';
import { useState } from 'react';
import fileIconUrl from '../assets/file_icon.svg';
import imageIconUrl from '../assets/image_icon.svg';
import { DocumentType } from '../utils/formUtils';

const DEFAULT_PAGE_SIZE = 4;

type ActivePagesList = {
  fileId: string;
  content?: File;
  index: number;
};

const PaginatedPreview = (document: DocumentType) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [isLightBoxPreviewOpen, setIsLightBoxPreviewOpen] = useState(false);
  const [targetFileSrc, setTargetFileSrc] = useState<string>('');

  const getActiveDocumentList = (): ActivePagesList[] => {
    const startIndex = currentPage === 0 ? 0 : (currentPage - 1) * DEFAULT_PAGE_SIZE;
    const endIndex = Math.min(startIndex + DEFAULT_PAGE_SIZE, document.files.length);

    // Map the subset of files to ActivePagesList
    const activeList = document.files.slice(startIndex, endIndex).map((file, index) => ({
      fileId: file.fileId,
      content: file.content,
      index: startIndex + index + 1,
    }));

    return activeList;
  };

  return (
    <>
      <Lightbox
        open={isLightBoxPreviewOpen}
        onClose={() => setIsLightBoxPreviewOpen(false)}
        slides={[
          {
            src: targetFileSrc,
          },
        ]}
      />
      <div className="bg-statusInformationLight px-7 py-7 rounded-sm flex flex-col lg:flex-row  lg:flex-wrap justify-between">
        {getActiveDocumentList().map((file) => {
          const fileSrc = file ? URL.createObjectURL(file.content as File) : '';

          return (
            <div key={file.fileId} className="lg:w-1/2 flex flex-col p-3 mb-7">
              <Heading as="h3">{file.index} ファイル目</Heading>
              <div className="flex justify-center bg-white min-h-full rounded-sm border-dashed border-black border-2 border-opacity-30 p-4 ">
                {file.content?.type === 'application/pdf' && (
                  <div className="flex flex-col items-center justify-center my-auto sm:pb-7">
                    <div>
                      <img src={fileIconUrl} alt="Adobe PDF Icon" className="min-h-28 max-h-28 mx-auto" />
                    </div>
                    <div>
                      <Text className="line-clamp-1" align="center">
                        {file.content.name}
                      </Text>
                    </div>
                  </div>
                )}

                {file.content?.type === 'image/tiff' && (
                  <div className="flex flex-col items-center justify-center my-auto sm:pb-7 w-full">
                    <div>
                      <img src={imageIconUrl} alt="TIFF Icon" className="min-h-28 max-h-28 mx-auto" />
                    </div>
                    <div>
                      <Text className="line-clamp-1" align="center">
                        {file.content.name}
                      </Text>
                    </div>
                  </div>
                )}

                {file.content?.type !== 'image/tiff' && file.content?.type !== 'application/pdf' && (
                  <div className="w-3/5 my-auto">
                    <img
                      src={fileSrc}
                      alt="Preview"
                      className="img-preview"
                      onClick={() => {
                        setIsLightBoxPreviewOpen(true);
                        setTargetFileSrc(fileSrc);
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
      {document.files.length > DEFAULT_PAGE_SIZE && (
        <div className="grid grid-cols-1 place-items-center bg-statusInformationLight pb-8 w-full">
          <Pagination
            totalItems={document.files.length}
            defaultPage={1}
            pageSize={DEFAULT_PAGE_SIZE}
            onPageChange={(pageNumber) => setCurrentPage(pageNumber)}
          />
        </div>
      )}
    </>
  );
};

export default PaginatedPreview;
